export default __webpack_public_path__ + "static/media/gallery_03.ed2decb5.jpg";